import $ from 'jquery';
import React from 'react';
import classnames from 'classnames';

import AdvancedOptions from './AdvancedOptions.js';
import AdvancedFundraiserOptions from './AdvancedFundraiserOptions.js';
import AdvancedPeopleOptions from './AdvancedPeopleOptions.js';
import AdvancedSchoolOptions from './AdvancedSchoolOptions.js';
import AdvancedTeamOptions from './AdvancedTeamOptions.js';

class SearchFormDesktop extends React.Component {
  state = {
    term: this.props.initialTerm || '',
    termType: this.props.initialTermType || 'user',
    showAdvanced: false,
    options: {},
  };

  componentDidMount() {
    if (this.props.initialTermType && this.props.initialTerm) {
      this._search();
    }
  }

  _optionsChanged = (o) => {
    this.setState({options: o});
  };

  _search = (event) => {
    if (event) {
      event.preventDefault();
    }
    const options = this.state.showAdvanced ? this.state.options : {};
    this.props.onSearch(this.state.termType, this.state.term, options);
    this.setState({showAdvanced: true});
    if (window.history && history.replaceState) {
      history.replaceState(null, null, '/search?' + $.param({
        termType: this.state.termType,
        term: this.state.term,
      }));
    }
  };

  _setTermType = (termType) => {
    this.setState({termType: termType}, () => {
      if (this.state.term) {
        this._search();
      }
    });
  };

  _termChanged = (event) => {
    this.setState({term: event.target.value});
  };

  _toggleAdvanced = (event) => {
    this.setState({showAdvanced: true});
  };

  render() {
    let termTypes = {
      user: 'People',
      team: 'Teams',
      school: 'HS/Colleges',
      fundraiser: 'Fundraisers',
      club: 'Clubs/Leagues',
      band: 'Bands',
    };

    let buttonClasses = Object.keys(termTypes).reduce((memo, k) => {
      memo[k] = classnames({'btn': true, 'btn-default': this.state.termType !== k, 'btn-primary': this.state.termType === k});
      return memo;
    }, {});

    let termTypeButtons = Object.keys(termTypes).map((termType, idx) => {
      return (
        <div className="btn-group" role="group" key={idx}>
          <button type="button" className={buttonClasses[termType]} onClick={this._setTermType.bind(null, termType)} disabled={this.props.loading}>{termTypes[termType]}</button>
        </div>
      );
    });

    let spinner = this.props.loading ? (<div className="btn-txt"><span className="loading-gif"></span></div>) : null;

    let advanced = null;
    let advancedToggle = null;
    if (!this.state.showAdvanced) {
      advancedToggle = (
        <a className="btn btn-blue-outline" onClick={this._toggleAdvanced}><span className="fa fa-search-plus" aria-hidden="true"/> Advanced Options</a>
      );
    } else if (this.state.termType === 'fundraiser') {
      advanced = (
        <AdvancedFundraiserOptions options={this.state.options} sports={this.props.sports} onChange={this._optionsChanged} />
      );
    } else if (this.state.termType === 'school') {
      advanced = (
        <AdvancedSchoolOptions options={this.state.options} sports={this.props.sports} onChange={this._optionsChanged} />
      );
    } else if (this.state.termType === 'team') {
      advanced = (
        <AdvancedTeamOptions options={this.state.options} sports={this.props.sports} onChange={this._optionsChanged} />
      );
    } else if (this.state.termType === 'user') {
      advanced = (
        <AdvancedPeopleOptions options={this.state.options} sports={this.props.sports} onChange={this._optionsChanged} />
      );
    } else {
      advanced = (
        <AdvancedOptions options={this.state.options} onChange={this._optionsChanged} />
      );
    }
    return (
      <form className="form-horizontal" onSubmit={this._search}>
        <div className="form-group">
          <div className="col-sm-offset-1 col-sm-10">
            <input type="text" className="form-control input-lg" value={this.state.term} onChange={this._termChanged} disabled={this.props.loading} required placeholder="Search The Blast Network" autoFocus autoCorrect="off" />
          </div>
        </div>
        <div className="form-group">
          <div className="col-sm-offset-1 col-sm-10">
            <div className="btn-group btn-group-justified" role="group">
              {termTypeButtons}
            </div>
          </div>
        </div>
        {advanced}
        <div className="form-group">
          <div className="col-sm-offset-1 col-sm-10">
            <div className="toright">
              {spinner}
              <button className="btn btn-primary" disabled={this.props.loading}>Search</button>
            </div>
            {advancedToggle}
          </div>
        </div>
      </form>
    );
  }
}

export default SearchFormDesktop;
